import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/ADD_CHILDEN_BULK_MODAL';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (payload: {institutionId: string; groupId: string}) => payload,
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: bulkAddChildrenSuccess} = createAction(
    `${domain}/BULK_ADD_CHILDREN_SUCCESS`,
    (childIds: string[], institutionId: string, groupId: string) => ({childIds, institutionId, groupId}),
);
